import { useOutsideClick } from "hooks/useOutsideClick";
import { useRef, useState } from "react";
import styled from "styled-components";
import { RoundedRadioButton } from "ui/base/roundedRadioButton/roundedRadioButton";
import { BankIcon, TrashIcon } from "ui/icons";
import { MoreDotsIcon } from "ui/icons/moreDots";
import { themeColor } from "ui/theme";

export const PayoutMethodItem = ({ method, onClick, bank_account_first_name, bank_account_last_name, bank_acccount_info, onDelete, onEdit }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const menuRef = useRef(null);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const closeDropdown = () => {
        setIsDropdownOpen(false);
    };

    useOutsideClick(menuRef, closeDropdown);

    return (
        <PayoutItem>
            <InfoContainer>
                <RoundedRadioButton onSelected={() => onClick(method)} isSelected={method.default} />
                <BankIcon color={"#A7A6CE"} width={24} height={24} />
                <BoldText>
                    {bank_account_first_name + ' ' + bank_account_last_name}, *****
                    {bank_acccount_info.slice(bank_acccount_info.length - 4)} (USD)
                </BoldText>
            </InfoContainer>
            {!method.default && <DropdownContainer ref={menuRef}>
                <ButtonContainer onClick={toggleDropdown}>
                    <MoreDotsIcon />
                    {isDropdownOpen && (
                        <DropdownMenu>
                            {/* <MenuItem onClick={onEdit}>
                                <PenIcon width={20} height={20} color={"#A7A6CE"} />
                                <MenuText>Edit</MenuText>
                            </MenuItem> */}
                            {!method.default && (
                                <MenuItem onClick={(() => onDelete(method.stripe_account))}>
                                    <TrashIcon width={20} height={20} color={"#A7A6CE"} />
                                    <MenuText>Delete</MenuText>
                                </MenuItem>
                            )}
                        </DropdownMenu>
                    )}
                </ButtonContainer>
            </DropdownContainer>}

        </PayoutItem>
    );
};


const BoldText = styled.p`
  font-family: Montserrat;
  font-weight: 600;
  
`

const MenuText = styled.p`
  margin-left: 6px;
`

const PayoutItem = styled.div`
  display: flex;
  flex-direction: row;
  border-width: 1px;
  border-style: solid;
  border-color: ${themeColor("mobileInputBorder")};
  border-radius: 8px;
  padding: 0.6rem;

  align-items: center;
  
`

const InfoContainer = styled.div`
  display: flex;
  flex:1;
  align-items: center;
  flex-direction: row;
  gap: 8px;
`

const ButtonContainer = styled.div`
  align-items: center;
  display: flex;
  cursor: pointer;
`


const DropdownContainer = styled.div`
    position: relative;
    display: flex;
`;

const DropdownMenu = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    background-color: white;
    border: 1px solid rgb(0 0 0 / 0.05);
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    margin-top: 8px;
    min-width: 220px;
    overflow: hidden;
    z-index: 10;
`;

const MenuItem = styled.a`
    display: flex;
    position: relative;
    flex-direction: row;
    padding: 12px 16px;
    text-decoration: none;
    color: ${themeColor("txt")};
    font-size: 14px;
    white-space: nowrap;
    font-weight: 500;
    cursor: pointer;

    &:hover {
        background-color: ${themeColor("bgNeutral")};
    }
`;